import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

import { OrganizationDataOutSchema } from 'src/utils/api.interfaces';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
  position: {
    width: '100vw',
    marginTop: '12%',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Poppins',
    fontSize: 48,
    color: '#165d5c',
    fontStyle: 'bold',
  },
  for: {
    fontFamily: 'Poppins',
    fontSize: 24,
    color: '#606462',
  },
  organization: {
    fontFamily: 'Poppins',
    width: '80%',
    margin: 'auto',
    padding: '20px',
  },
  subtitle: {
    fontFamily: 'Poppins',
    width: '70%',
    color: '#606462',
    margin: 'auto',
  },
});

const getFontSize = (text: string) => {
  if (text.length < 50) return '32px';
  else if (text.length < 80) return '28px';
  else if (text.length < 100) return '24px';
  return '16px';
};

interface Props {
  organization: OrganizationDataOutSchema;
}

export default function Content(props: Readonly<Props>) {
  const { organization } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'ghg.certificate' });

  const organizationStyle = {
    ...styles.organization,
    fontSize: getFontSize(organization.name),
  };

  return (
    <View style={styles.position}>
      <Text style={styles.title}>{t('certificate')}</Text>
      <Text style={styles.for}>{t('forTheCompany')}</Text>
      <Text style={organizationStyle}>{organization.name}</Text>
      <Text style={styles.subtitle}>{t('confirmation1')}</Text>
      <Text style={styles.subtitle}>{t('confirmation2')}</Text>
    </View>
  );
}
